<template>
  <ul id="features-one-list" class="mt-10">
    <li>
      <div class="flex">
        <div class="flex-shrink-0">
          <div
              class="flex items-center justify-center h-12 w-12 rounded-md bg-green-300 text-white"
          >
            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
              />
            </svg>
          </div>
        </div>
        <div class="ml-4">
          <h5 class="text-lg leading-6 font-medium text-gray-900">Turvalisus</h5>
          <p
              class="mt-2 font-normal text-base leading-6 tracking-wide text-primary-gray"
          >Kodulehed on majutatud turvalistesse Google serveritesse.</p>
        </div>
      </div>
    </li>
    <li class="mt-10">
      <div class="flex">
        <div class="flex-shrink-0">
          <div
              class="flex items-center justify-center h-12 w-12 rounded-md bg-green-300 text-white"
          >
            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"
              />
            </svg>
          </div>
        </div>
        <div class="ml-4">
          <h5 class="text-lg leading-6 font-medium text-gray-900">Järelmaksuga koduleht</h5>
          <p class="mt-2 font-normal text-base leading-relaxed tracking-wide text-primary-gray">
            Oleme abiks alustavale ettevõttele, meie valmistatud kodulehe eest on võimalik tasuda järelmaksuga.
          </p>
        </div>
      </div>
    </li>
    <li class="mt-10">
      <div class="flex">
        <div class="flex-shrink-0">
          <div
              class="flex items-center justify-center h-12 w-12 rounded-md bg-green-300 text-white"
          >
            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M13 10V3L4 14h7v7l9-11h-7z"
              />
            </svg>
          </div>
        </div>
        <div class="ml-4">
          <h5
              class="text-lg leading-6 font-medium text-gray-900"
          >Otsingumootori optimiseerimine</h5>
          <p class="mt-2 font-normal text-base leading-relaxed tracking-wide text-primary-gray">
            Hea asukoht otsingumootorite tipus, on nagu hea asukohaga kinnisvara. Me kasutame parimaid
            praktikaid ja nippe, et aidata Teie lehel olla võimalikult nähtavad.
          </p>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import {gsap} from 'gsap'

export default {
  name: "FeaturesOneList",
  computed: {
    elements: function () {
      return gsap.utils.toArray('#features-one-list > li')
    }
  },
  methods: {
    animationsInit() {
      const scroller = this.$parent.$parent.$parent.$refs["scrollSections"];
      this.elements.forEach(element => {
        gsap.to(element, {
          scrollTrigger: {
            trigger: element,
            scroller: scroller,
            start: 'top 95%',
            end: "bottom 25%",
          },
          ease: 'slow',
          y: 0,
          opacity: 1,
          autoAlpha: 1,
          duration: 1
        })
      })
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.elements.forEach(element => {
        gsap.set(element, {
          y: 100,
          opacity: 0,
          autoAlpha: 0
        })
      })
      this.animationsInit()
    })
  }
}
</script>

<style scoped>

</style>
